module.exports = __webpack_public_path__ + "static/media/arrowDown.77fc2c36.svg";